export function trimAddress(address) {
    address = address ? address.toString() : "";
    return address.slice(0, 6) + "..." + address.slice(-4);
}
